import React, { Component, Fragment } from 'react';
// import { withAlert } from 'react-alert'

import { Link } from 'react-router-dom';
// import Message from '../../components/Dashboard/Message';
// import MessageRead from '../../components/Dashboard/MessageRead';
import moment from 'moment'
class Dashboard extends Component {
    state = {

    }
    alertOptions = {
        offset: 65,
        position: 'top left',
        theme: 'dark',
        time: 1000,
        transition: 'scale'
    }

    openTab(evt, tabName) {

        var i, tabcontent, tablinks;

        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }

        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        document.getElementById(tabName).style.display = "block";
        evt.currentTarget.className += " active";
    }

    openChat(evt, chatName) {

        var i, chatcontent, chatlinks;

        chatcontent = document.getElementsByClassName("chatcontent");
        for (i = 0; i < chatcontent.length; i++) {
            chatcontent[i].style.display = "none";
        }

        chatlinks = document.getElementsByClassName("chatlinks");
        for (i = 0; i < chatlinks.length; i++) {
            chatlinks[i].className = chatlinks[i].className.replace("selected", " ");


        }

        document.getElementById(chatName).style.display = "block";
        evt.currentTarget.className += " selected";
    }
    render() {

        return (
            <Fragment>
                <div class="right-section">
                    <div class="row nopadding ">
                        <div class="tab col-md-12">
                            <button class="tablinks w-50" onClick={(e) => this.openTab(e, "overdue")}>overdue</button>
                            <button class="tablinks w-50" onClick={(e) => this.openTab(e, "ontrack")}>ontrack</button>
                        </div>
                        <div id="overdue" style={{ display: "block" }} class="col-md-12 nopadding tabcontent active">
                            <div class=" col-md-8 nopadding" >
                                <div class="card-container">
                                    <div class="card-filer">
                                        <ul>
                                            <li><a href="#" class="selected chatlinks" onClick={(e) => this.openChat(e, "all")}>All</a></li>
                                            <li><a href="#" class="chatlinks" onClick={(e) => this.openChat(e, "read")}>Read</a></li>
                                            <li><a href="#" class="chatlinks" onClick={(e) => this.openChat(e, "unread")}>Unread</a></li>
                                        </ul>
                                    </div>
                                    <div id="all" class="chatcontent">
                                        {/* <Message 
                                                /> */}
                                        {/* <MessageRead 
                                                /> */}
                                    </div>
                                    {/* Read */}

                                    {/* <div id="read" class="chatcontent  " style={{ display: 'none' }}>
                                                <div class="card-light">
                                                    <a href="#">
                                                        <div class="feed-unread"><i class="fa fa-bell"></i></div>
                                                        <h4>Nethan garments, Chennai is confirmed your design NBEY244 - utility shirt dress </h4>
                                                    </a>
                                                    <p>2 hours ago | for your order id : SR-064764 | Style No : 34452</p>
                                                    <p>Confirmed </p>
                                                </div>

                                                <div class="card-light card-light-viewd">
                                                    <a href="#">
                                                        <div class="feed-read"><i class="icons icon-bell"></i></div>
                                                        <h4>Matala Mainrange Papaya , Mumbai is confirmed your design SBEY254 - Men's shirt dress </h4>
                                                    </a>
                                                    <p>3 hours ago | for your order id : SR-065764 | Style No : 37452</p>
                                                    <p>Confirmed </p>
                                                </div>
                                            </div> */}
                                    {/* Unread */}
                                    {/* <div id="unread" class="chatcontent  " style={{ display: 'none' }}>

                                                <div class="card-light">
                                                    <a href="#">
                                                        <div class="feed-unread"><i class="fa fa-bell"></i></div>
                                                        <h4>Best Seller India verdo moda, Delhi is requested new design - Initial Design </h4>
                                                    </a>
                                                    <p>2 hours ago | new order id : SR-064764 | Style No : 34452</p>
                                                    <p>Confirmed </p>
                                                </div>

                                                <div class="card-light">
                                                    <a href="#">
                                                        <div class="feed-unread"><i class="fa fa-bell"></i></div>
                                                        <h4>Next Ladies wears Casuals, Chennai is requested a new design ST55451 - VM Truper Ls shirt  </h4>
                                                    </a>
                                                    <p>10 hours ago | for your order id : NL-064764 | Style No : 454514</p>
                                                    <p>Confirmed </p>
                                                </div>
                                                <div class="card-light card-light-viewd">
                                                    <a href="#">
                                                        <div class="feed-read"><i class="icons icon-bell"></i></div>
                                                        <h4>Nethan garments,Chennai is confirmed your design NBEY244 - utility shirt dress </h4>
                                                    </a>
                                                    <p>2 hours ago | for your order id : SR-064764 | Style No : 34452</p>
                                                    <p>Confirmed </p>
                                                </div>
                                            </div> */}
                                    <div class="load-more">
                                        <ul>
                                            <li class="next"><a href="#">Next</a></li>
                                            <li class="prev"><a href="#" class="inactive">Prev</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 nopadding">
                                <div class="right-section-more">
                                    <div class="activites-card text-center">
                                        <h1>Magnum Calendar</h1>
                                        <p><i class="icons icon-calendar"></i> {moment().format('DD MMM YYYY')}</p>
                                        <Link to="/calendar"><a href="#" class="primary">Create Event</a></Link>
                                    </div>
                                    <div class="activites-card">
                                        <h5>Magnum Messenger</h5>
                                        <div class="chatNotifyerBox">
                                            <Link to="/communication"><a href="">
                                                <ul>
                                                    <li>Communication</li>
                                                    <li>Style 36502</li>
                                                    <li><p>3</p></li>
                                                </ul>
                                                <ul>
                                                    <li>Communication</li>
                                                    <li>Style 36402</li>
                                                    <li><p>11</p></li>
                                                </ul>
                                            </a></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="ontrack" class="tabcontent col-md-12 nopadding ">
                        <h3>ontrack</h3>
                        <p>ontrack is the capital of ontrack.</p>
                    </div>

                </div>
            </Fragment>
        );
    }
}

export default Dashboard;










// WEBPACK FOOTER //
// ./src/pages/dashboard/page.js